/**
 * 禪心連線（實況留言板）Mock 資料 - 符合真實 API 格式
 */

// 模擬 POST /v1/interact/board/list 的回應
export const mockBoardListResponse = {
  current_page: 1,
  items: [
    {
      board_id: 1,
      title: '35週年慶典活動',
      comment_switch: true,
      like_switch: true,
      visible: true,
      settled: false,
      settled_at: null,
      start_time: 'Wed, 18 Mar 2026 10:00:00 GMT',
      end_time: 'Tue, 31 Mar 2026 10:00:00 GMT',
      created_at: 'Wed, 18 Mar 2026 09:00:00 GMT',
      modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT',
    },
    {
      board_id: 2,
      title: '禪修共修',
      comment_switch: true,
      like_switch: false,
      visible: true,
      settled: false,
      settled_at: null,
      start_time: 'Thu, 19 Mar 2026 10:00:00 GMT',
      end_time: 'Fri, 20 Mar 2026 10:00:00 GMT',
      created_at: 'Wed, 18 Mar 2026 09:00:00 GMT',
      modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT',
    },
  ],
  message: 'Success',
  result_code: 200,
  total: 2,
  total_items: 2,
  total_pages: 1,
};

// 模擬 POST /v1/interact/board/topic/list 的回應，依 board_id 分組
export const mockTopicListByBoard = {
  1: {
    board_details: {
      comment_switch: true,
      created_at: 'Wed, 18 Mar 2026 09:00:00 GMT',
      end_time: 'Tue, 31 Mar 2026 10:00:00 GMT',
      like_switch: true,
      modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT',
      start_time: 'Wed, 18 Mar 2026 10:00:00 GMT',
      title: '35週年慶典活動',
      visible: true,
    },
    board_id: 1,
    current_page: 1,
    items: [
      { topic_id: 1, title: '開山大典・傳燈法會', content: '住持和尚主法，傳燈儀式莊嚴展開，共同點亮智慧之燈。', visible: true, created_at: 'Wed, 18 Mar 2026 09:00:00 GMT', modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT' },
      { topic_id: 2, title: '法鼓梵唄・音聲供養', content: '大眾同聲梵唄，以清淨音聲供養十方諸佛，功德無量。', visible: true, created_at: 'Wed, 18 Mar 2026 09:00:00 GMT', modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT' },
      { topic_id: 3, title: '圓滿回向・大眾祈福', content: '三十五週年圓滿回向，祈願正法久住，眾生離苦得樂。', visible: true, created_at: 'Wed, 18 Mar 2026 09:00:00 GMT', modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT' },
    ],
    message: 'Success',
    result_code: 200,
    total: 3,
    total_items: 3,
    total_pages: 1,
  },
  2: {
    board_details: {
      comment_switch: true,
      created_at: 'Wed, 18 Mar 2026 09:00:00 GMT',
      end_time: 'Fri, 20 Mar 2026 10:00:00 GMT',
      like_switch: false,
      modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT',
      start_time: 'Thu, 19 Mar 2026 10:00:00 GMT',
      title: '禪修共修',
      visible: true,
    },
    board_id: 2,
    current_page: 1,
    items: [
      { topic_id: 4, title: '靜心共修', content: '法師引導禪坐，體驗身心清涼自在。', visible: true, created_at: 'Wed, 18 Mar 2026 09:00:00 GMT', modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT' },
      { topic_id: 5, title: '早課共修', content: '大眾共誦早課，啟發菩提心，廣結善緣。', visible: true, created_at: 'Wed, 18 Mar 2026 09:00:00 GMT', modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT' },
    ],
    message: 'Success',
    result_code: 200,
    total: 2,
    total_items: 2,
    total_pages: 1,
  },
};

// Mock 留言列表 - 符合真實 API 格式 POST /v1/comment/list
export const mockCommentListByTopic = {
  1: {
    current_page: 1,
    items: [
      { comment_id: 1, content: '感恩住持和尚慈悲開示，每一句法語都深入心田，法喜充滿！', created_at: 'Wed, 19 Mar 2026 08:05:00 GMT', dharma_name: '法明', commenter_name: '普台・法明', like_count: 12, modified_at: 'Wed, 19 Mar 2026 08:05:00 GMT', rank: 1, user_id: 1, user_name: '陳大華', approved: true },
      { comment_id: 2, content: '中台山三十五週年，願正法久住，佛法昌盛，利益一切眾生！', created_at: 'Wed, 19 Mar 2026 08:07:00 GMT', dharma_name: '慧蓮', commenter_name: '慧蓮', like_count: 8, modified_at: 'Wed, 19 Mar 2026 08:07:00 GMT', rank: 2, user_id: 2, user_name: '王小明', approved: true },
      { comment_id: 3, content: '第一次參加線上活動，感覺非常殊勝！南無本師釋迦牟尼佛', created_at: 'Wed, 19 Mar 2026 08:10:00 GMT', dharma_name: '無', commenter_name: null, like_count: 5, modified_at: 'Wed, 19 Mar 2026 08:10:00 GMT', rank: 3, user_id: 3, user_name: 'Guest', approved: true },
      { comment_id: 4, content: '感謝所有義工菩薩的付出，數百位志工默默護持，真的辛苦了！', created_at: 'Wed, 19 Mar 2026 08:12:00 GMT', dharma_name: '普賢', commenter_name: '普賢', like_count: 20, modified_at: 'Wed, 19 Mar 2026 08:12:00 GMT', rank: null, user_id: 4, user_name: '陳志明', approved: true },
    ],
    top_items: [
      { comment_id: 4, content: '感謝所有義工菩薩的付出，數百位志工默默護持，真的辛苦了！', created_at: 'Wed, 19 Mar 2026 08:12:00 GMT', dharma_name: '普賢', commenter_name: '普賢', like_count: 20, modified_at: 'Wed, 19 Mar 2026 08:12:00 GMT', rank: 1, user_id: 4, user_name: '陳志明', approved: true },
      { comment_id: 1, content: '感恩住持和尚慈悲開示，每一句法語都深入心田，法喜充滿！', created_at: 'Wed, 19 Mar 2026 08:05:00 GMT', dharma_name: '法明', commenter_name: '普台・法明', like_count: 12, modified_at: 'Wed, 19 Mar 2026 08:05:00 GMT', rank: 2, user_id: 1, user_name: '陳大華', approved: true },
      { comment_id: 2, content: '中台山三十五週年，願正法久住，佛法昌盛，利益一切眾生！', created_at: 'Wed, 19 Mar 2026 08:07:00 GMT', dharma_name: '慧蓮', commenter_name: '慧蓮', like_count: 8, modified_at: 'Wed, 19 Mar 2026 08:07:00 GMT', rank: 3, user_id: 2, user_name: '王小明', approved: true },
    ],
    topic_details: { title: '開山大典・傳燈法會', content: '住持和尚主法，傳燈儀式莊嚴展開。', visible: true, created_at: 'Wed, 18 Mar 2026 09:00:00 GMT', modified_at: 'Wed, 18 Mar 2026 09:00:00 GMT' },
    topic_id: 1,
    total: 4,
    total_items: 4,
    total_pages: 1,
    top_total: 3,
    message: 'Success',
    result_code: 200,
  },
};

// 舊版 mock 保留（內部預計用）
export const mockCommentsByTopic = {
  1: [
    { id: 1, content: '感恩住持和尚慈悲開示，每一句法語都深入心田，法喜充滿！', created_at: '2026-03-19T08:05:00Z', like_count: 12 },
    { id: 2, content: '中台山三十五週年，願正法久住，佛法昌盛，利益一切眾生！', created_at: '2026-03-19T08:07:30Z', like_count: 8 },
    { id: 3, content: '第一次參加線上活動，感覺非常殊勝！南無本師釋迦牟尼佛', created_at: '2026-03-19T08:10:00Z', like_count: 5 },
  ],
  2: [
    { id: 7, content: '梵唄聲聲入耳，滌盡塵勞，身心頓覺清涼自在。', created_at: '2026-03-19T10:00:00Z', like_count: 15 },
    { id: 8, content: '音聲是最美的供養，感恩法師們的用心唱誦！', created_at: '2026-03-19T10:08:00Z', like_count: 7 },
  ],
  3: [
    { id: 9, content: '回向功德給所有參與的善知識，祝福大家平安吉祥！', created_at: '2026-03-19T11:00:00Z', like_count: 18 },
    { id: 10, content: '三十五年，每一步都是願力的實踐，感恩中台山的引領。', created_at: '2026-03-19T11:05:00Z', like_count: 22 },
  ],
  4: [
    { id: 12, content: '靜坐片刻，心如止水，感謝這份殊勝因緣。', created_at: '2026-03-19T06:10:00Z', like_count: 6 },
  ],
  5: [
    { id: 14, content: '願以此共修功德，迴向法界一切有情，早日成就菩提。', created_at: '2026-03-19T07:05:00Z', like_count: 11 },
  ],
};
